<form [formGroup]="applicantDetailsParentForm" #inputRef>
  <fieldset class="form-group">
    <div class="row">
      <div class="col-12">
        <legend>Is this application being made on behalf of a company or limited liability partnership?</legend>
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex">
          <div class="w-40 mr-1">
            <div class="c-radio--separated">
              <span class="c-radio-button">
                <input type="radio" name="tad_business_personal" formControlName="tad_business_personal" [checked]="tad_business_personal.value == 'business'" id="business" value="business">
                <label class="c-radio-button__label" for="business">
                  <span class="c-radio-button__faux">Yes</span>
                  <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13">
                    <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
                  </svg>
                </label>
              </span>
            </div>
          </div>
          <div class="w-40">
            <div class="c-radio--separated">
              <span class="c-radio-button">
                <input type="radio" name="tad_business_personal" formControlName="tad_business_personal" [checked]="tad_business_personal.value == 'personal'" id="personal" value="personal">
                <label class="c-radio-button__label" for="personal">
                  <span class="c-radio-button__faux">No</span>
                  <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13">
                    <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
                  </svg>
                </label>
              </span>
            </div>
          </div>
          <div class="w-20"></div>
        </div>
      </div>
    </div>
  </fieldset>
  @if (tad_business_personal.value == 'business') {
    <together-auction-dip-applicant-company [is_business]="tad_business_personal.value == 'business'" [business_applicant]="business_applicant" [incoming_case_id]="incoming_case_id" [doSaveBusinessApp]="doSaveBusinessApp" (doSaveSuccess)="handleBusinessAppSaveSuccess($event)" (form_out)="_handleIncomingFormUpdate($event)" (updating_loading_status)="updateLoadingStatusFromChild($event)" [is_enabled]="tad_business_personal.value != 'business'"></together-auction-dip-applicant-company>
  }

  @if (tad_business_personal.value != null) {
    <ng-container formArrayName="tad_applicants">
      @for (applicant of DisplayApplicants; track applicant; let i = $index) {
        <together-auction-dip-applicant [is_business_applicant]="tad_business_personal.value == 'business'" [iterator]="i" [do_validate]="_do_validate" [do_save]="_do_save" [incoming_case_id]="incoming_case_id" [applicant]="applicant" [business_details]="BusinessDetails" [loan_details]="loan_details" [isSubmitting]="_isSubmitting" [hasLived3yearSelected]="hasLived3yearSelected" [hasTitleNotSelected]="hasTitleNotSelected" (applicant_updated)="_handleChildUpdated($event)" (applicant_deleted)="_handleChildDeleted($event)" (address_select)="_handleAddressSelectDisplayed($event)" (save_success)="_handleApplicantSaveSuccess($event)" (save_error)="_handleApplicantSaveError($event)" (pass_form)="_handleFormFromChild($event)" (hasPreviousApplicantSaved)="_handleApplicantPreviousApplicantSave($event)" [collapseAllApplicant]="collapseAllApplicant" (updating_loading_status)="updateLoadingStatusFromChild($event)">
        </together-auction-dip-applicant>
      }
    </ng-container>
  }
</form>
<together-auction-dip-stage-select [forward_title]="'Income details'" [backward_title]="'Loan details'" [action_title]="'Add another applicant'" [show_action]="_showAction" [show_forward]="true" [show_backward]="true" (on_forward)="_handleForward($event)" [disabled]="applicantDetailsParentForm.get('tad_business_personal').invalid" [forward_disabled]="applicantDetailsParentForm.get('tad_business_personal').invalid" (on_action)="_handleAction($event)" (on_backward)="_handleBackward($event)">
</together-auction-dip-stage-select>
<together-auction-dip-loading [is_loading]="_isLoading"></together-auction-dip-loading>
